import { ThemeDefault } from '@paygreen/paygreen-ui';

export const activationStatusOptions = {
    CREATED: {
        colorPallet: 'wab',
        color: 'grey50',
        icon: 'CrossIcon',
    },
    DELETED: {
        colorPallet: 'status',
        color: 'danger',
        icon: 'CrossIcon',
    },
    VALIDATED: {
        colorPallet: 'status',
        color: 'success',
        icon: 'CheckIcon',
    },
};

export const stripeAccountStatusOptions = {
    NONE: {
        colorPallet: 'wab',
        color: 'grey50',
        icon: 'EmptyIcon',
    },
    TOCREATE: {
        colorPallet: 'status',
        color: 'danger',
        icon: 'PlusIcon',
    },
    TOVALIDATE: {
        colorPallet: 'status',
        color: 'warning',
        icon: 'StartIcon',
    },
    VALIDATED: {
        colorPallet: 'status',
        color: 'success',
        icon: 'CheckIcon',
    },
};

export const sepaStatusOptions = {
    ERROR: {
        colorPallet: 'status',
        color: 'danger',
        icon: 'CrossIcon',
    },
    SIGNED: {
        colorPallet: 'status',
        color: 'success',
        icon: 'PenIcon',
    },
    UNSIGNED: {
        colorPallet: 'wab',
        color: 'grey50',
        icon: 'EmptyIcon',
    },
};

export const accountStatusOptions = {
    EMPTY: {
        colorPallet: 'wab',
        color: 'grey50',
        icon: 'EmptyIcon',
    },
};

export const activatedSpacesStatusOptions = {
    NOTACTIVATED: {
        colorPallet: 'wab',
        color: 'grey50',
        icon: 'EmptyIcon',
    },
    ACTIVATED: {
        colorPallet: 'status',
        color: 'success',
        icon: 'CheckIcon',
    },
};

export const expirationDateStatusOptions = {
    EXPIRED: {
        colorPallet: 'status',
        color: 'danger',
        icon: 'CrossIcon',
    },
    NOTEXPIRED: {
        colorPallet: 'status',
        color: 'success',
        icon: 'CheckIcon',
    },
};

export const subscriptionStatusOptions = {
    NONE: {
        colorPallet: 'status',
        color: 'danger',
        icon: 'CrossIcon',
    },
    SHOP: {
        colorPallet: 'status',
        color: 'success',
        icon: 'CheckIcon',
    },
    CUSTOMER: {
        colorPallet: 'status',
        color: 'success',
        icon: 'CheckIcon',
    },
};

export const visibilityStatusOptions = {
    NOTVISIBLE: {
        colorPallet: 'status',
        color: 'warning',
        icon: 'CrossIcon',
    },
    VISIBLE: {
        colorPallet: 'status',
        color: 'success',
        icon: 'EyeIcon',
    },
};

export const actionIconProps = (condition) => {
    return {
        iconSize: 'sm',
        colorPallet: 'status',
        hasBackground: true,
        hasHover: condition,
        htmlTag: condition ? 'button' : 'span',
        style: condition
            ? null
            : {
                  filter: 'grayscale(1)',
              },
    };
};

export const actionCellboxProps = (condition) => {
    return {
        style: {
            display: condition ? null : 'flex',
            justifyContent: condition ? null : 'flex-end',
            overflow: 'visible',
        },
    };
};

export const widthCellboxProps = (condition, width) => {
    return {
        style: {
            maxWidth: condition ? ThemeDefault.blockHeader[width] : null,
        },
    };
};

export const spacesManagementList = [
    {
        name: 'charityKitStatus',
        type: 'status',
        value: ['usesArrondi'],
    },
    {
        name: 'charityKitSEPAStatus',
        type: 'status',
        value: ['charityBilling', 'status'],
    },
    {
        name: 'charityKitExpirationDateMode',
        type: 'date',
        value: ['charityExpirationDate'],
    },
    {
        name: 'charityKitSetupPrice',
        type: 'price',
        value: ['charityBilling', 'setupPrice'],
    },
    {
        name: 'charityKitSubscriptionMode',
        type: 'price',
        value: ['charityBilling', 'setupPrice'],
    },
    {
        name: 'climateKitStatus',
        type: 'status',
        value: ['usesTree'],
    },
    {
        name: 'climateKitSEPAStatus',
        type: 'status',
        value: ['climateBilling', 'status'],
    },
    {
        name: 'climateKitExpirationDateMode',
        type: 'date',
        value: ['climateExpirationDate'],
    },
    {
        name: 'climateKitSetupPrice',
        type: 'price',
        value: ['climateBilling', 'setupPrice'],
    },
    {
        name: 'climateKitSubscriptionMode',
        type: 'price',
        value: ['climateBilling', 'setupPrice'],
    },
    {
        name: 'climateKitContributionMode',
        type: 'price',
        value: ['contribution_mode'],
    },
];

export const companyManagementList = [
    {
        name: 'siret',
        type: 'text',
        value: ['organisationIdentificationNumber'],
    },
    {
        name: 'website',
        type: 'link',
        value: ['organisationWebsite'],
    },
];

export const accountManagementList = [
    {
        name: 'subscriptionDate',
        type: 'date',
        value: ['administrator', 'createdAt'],
    },
    {
        name: 'activationStatus',
        type: 'status',
        value: ['administrator', 'enabledAt'],
    },
];

export const accountCharityManagementList = [
    {
        name: 'subscriptionDate',
        type: 'date',
        value: ['representative', 'createdAt'],
    },
    {
        name: 'activationStatus',
        type: 'status',
        value: ['representative', 'enabledAt'],
    },
];

export const administratorManagementList = [
    {
        name: 'administrator',
        type: 'text',
        value: [
            ['administrator', 'firstname'],
            ['administrator', 'lastname'],
        ],
    },
    {
        name: 'phone',
        type: 'phone',
        value: ['administrator', 'contact', 'phone'],
    },
    {
        name: 'email',
        type: 'link',
        value: ['administrator', 'contact', 'email'],
    },
];

export const representativeManagementList = [
    {
        name: 'administrator',
        type: 'text',
        value: [
            ['representative', 'firstname'],
            ['representative', 'lastname'],
        ],
    },
    {
        name: 'phone',
        type: 'phone',
        value: ['representative', 'contact', 'phone'],
    },
    {
        name: 'email',
        type: 'link',
        value: ['representative', 'contact', 'email'],
    },
];

export const charityManagementList = [
    {
        name: 'url',
        type: 'link',
        value: ['association', 'url'],
    },
    {
        name: 'fieldOfAction',
        type: 'fieldOfAction',
        value: ['association', 'fieldOfAction'],
    },
    {
        name: 'description',
        type: 'text',
        value: ['association', 'description'],
    },
    {
        name: 'visible',
        type: 'status',
        value: ['association', 'visible'],
    },
];
